import { getData, putData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import {
  handleApiSuccess,
  handleApiError,
  generateUserInfoHeader,
  getDataFromSessionStorage,
  getAPIEndpoints,
} from 'src/utils';

const classroomAttendanceActionTypes = {
  GET_CLASS_ATTENDANCE_DETAILS: 'GET_CLASS_ATTENDANCE_DETAILS',
  GET_STUDENTS_ATTENDANCE_DETAILS: 'GET_STUDENTS_ATTENDANCE_DETAILS',
  STUDENTS_LIST_SUCCESS: 'STUDENTS_LIST_SUCCESS',
};

const ClassroomAttendanceSuccessAction = payload => {
  return {
    type: classroomAttendanceActionTypes.GET_CLASS_ATTENDANCE_DETAILS,
    payload,
  };
};

const StudentsAttendanceSuccessAction = payload => {
  return {
    type: classroomAttendanceActionTypes.GET_STUDENTS_ATTENDANCE_DETAILS,
    payload,
  };
};

const StudentsSuccessAction = payload => {
  return {
    type: classroomAttendanceActionTypes.STUDENTS_LIST_SUCCESS,
    payload,
  };
};

const GetClassRoomAttendanceDetails = (url, metaData) => {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(
        url,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(ClassroomAttendanceSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(ClassroomAttendanceSuccessAction({}));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
};

const GetStudentsAttendanceDetails = (url, metaData) => {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(
        url,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(StudentsAttendanceSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      const studentIdData = {
        studentIds: response?.data?.data?.page?.map(id => id.studentId),
      };
      dispatch(
        GetStudentsListbyStudentIds(getAPIEndpoints().getStudentsListByStudentIds, studentIdData)
      );
      return true;
    } catch (err) {
      dispatch(StudentsAttendanceSuccessAction({}));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
};

const GetStudentsListbyStudentIds = (url, payload, headers) => {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(StudentsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(StudentsSuccessAction({ data: [] }));
      return false;
    }
  };
};

export {
  classroomAttendanceActionTypes,
  ClassroomAttendanceSuccessAction,
  GetClassRoomAttendanceDetails,
  GetStudentsAttendanceDetails,
  GetStudentsListbyStudentIds,
};
